<template>
    <div class="left-echarts">
        <h1>常温机组柱状图</h1>
        <div class="line"></div>
        <div class="use">
            <div class="tab">
                <div class="tab-title" v-for="(item, index) in arr" :key="index" :class="{ active: cur == index }"
                    @click="handleClick(item.text, index)">
                    <p>{{ item.title }}</p>
                </div>
            </div>
            <div class="select">
                <el-select v-model="value">
                    <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="echart">
            <div class="dom" id="dom10"></div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
export default {
    data() {
        return {
            myChart: null,

            // 下拉选择框
            options: [
                {
                    value: "1",
                    label: "进水测",
                    names: [
                        "en_1.PV,en_3.PV,en_5.PV,en_7.PV,en_9.PV,en_11.PV,en_13.PV,en_15.PV",
                        "en_29.PV,en_31.PV,en_33.PV,en_35.PV,en_37.PV,en_39.PV,en_41.PV,en_43.PV"]
                },
                {
                    value: "2",
                    label: "出水侧",
                    names: ["en_2.PV,en_4.PV,en_6.PV,en_8.PV,en_10.PV,en_12.PV,en_14.PV,en_16.PV",
                        "en_30.PV,en_32.PV,en_34.PV,en_36.PV,en_38.PV,en_40.PV,en_42.PV,en_44.PV"]
                }
            ],
            value: "1",
            cur: 0,
            arr: [
                {
                    title: "温度",
                    text: "1",
                    yName: "温度(℃)",
                },
                {
                    title: "压力",
                    text: "2",
                    yName: "压力(MPa)",
                    // interval:0.2
                },
            ],
            xData: ["1#蒸发", "1#冷凝", "2#蒸发", "2#冷凝", "3#蒸发", "3#冷凝", "4#蒸发", "4#冷凝",],
        };
    },
    methods: {
        handleClick(params, index) {
            this.cur = index;
            this.handleGetData();
        },
        handleEchart() {
            // 1局部方法 echarts.init
            this.myChart = echarts.init(document.getElementById("dom10"));
            // 2 指定图表的配置项和数据 (书写配置项，设置图表的内容)
            let option = {
                grid: {
                    top: "15%",
                    left: "8%",
                    right: "7%",
                    bottom: "1%",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    borderColor: "transparent",
                    textStyle: {
                        fontSize: 12,
                        fontWeight: "400",
                        color: "#fff",
                    },
                },
                xAxis: {
                    type: "category",
                    data: this.xData,
                    name: "(h)",
                    nameTextStyle: {
                        color: "rgba(255,255,255,0.8)",
                        verticalAlign: "top",
                        lineHeight: 26,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                        },
                    },
                    axisLabel: {
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 9,
                    },
                },
                yAxis: {
                    type: "value",
                    name: "温度(℃)",
                    nameTextStyle: {
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 15,
                        lineHeight: 40,
                    },
                    nameLocation: "middle",
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                        },
                    },

                    axisLabel: {
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 14,
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        name: this.arr[this.cur].title,
                        data: [36, 35.8, 35.9, 36, 36.1, 36.2, 35.9, 36],
                        type: "bar",
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                { offset: 0, color: "rgba(2, 99, 235, 1)" },
                                {
                                    offset: 1,
                                    color: "rgba(168, 255, 252, 1)",
                                },
                            ]
                            ),
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                {
                                    offset: 0,
                                    color: "rgba(2, 99, 235, 0.8)",
                                },
                                {
                                    offset: 1,
                                    color: "rgba(168, 255, 252, 0.2)",
                                },
                            ]
                            ),
                        },
                    },
                ],
            };
            // 3 使用刚指定的配置项和数据显示图表。（添加到div中）
            this.myChart.setOption(option);
            // 4 图表的响应式
            window.onresize = () => {
                this.myChart.resize();
            };
        },

        handleAdd() {
            setInterval(() => {
                this.cur += 1;
                if (this.cur == this.arr.length) {
                    this.cur = 0;
                }
                this.handleGetData();
            }, 60*1000*5)
        },
        // 获取数据
        handleGetData() {
            getRequest("/api/realdata", {
                names: this.options[this.value - 1].names[this.cur],
                token: sessionStorage.getItem("realTimeToken"),
                decimal: 2,
            }).then((res) => {
                if (res.code == 0) {
                    this.myChart.setOption({
                        series: [
                            {
                                name: this.arr[this.cur].title,
                                data: res.items.map((item) => item.val),
                            },
                        ],
                        yAxis: {
                            name: this.arr[this.cur].yName,
                        },
                    });
                }
            })
        },
    },
    mounted() {
        this.handleEchart();
        this.handleAdd()
        this.handleGetData();
    },
    watch: {
        value(newVal) {
            console.log(newVal);
            if (newVal == 1) {
                this.handleGetData();
            } else if (newVal == 2) {
                this.handleGetData();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.left-echarts::v-deep {
    height: 320px;

    h1 {
        margin: 0px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005ec9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .use {
        display: flex;
        justify-content: space-between;
        margin: 4px 0 0;

        .tab {
            display: flex;

            .tab-title {
                text-align: center;
                margin: 0 5px;
                width: 78px;
                height: 22px;
                border: 1px solid #00fff2;
                box-sizing: border-box;

                p {
                    display: inline-block;
                    width: 60px;
                    height: 22px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 22px;
                }

                &.active {
                    background: linear-gradient(122deg,
                            #0f65ea 0%,
                            #00d9ea 100%);
                    border: none;
                }
            }
        }

        .select {
            input {
                text-align: center;
                margin: 0 5px;
                width: 90px;
                height: 20px;
                box-sizing: border-box;
                background: linear-gradient(122deg, #0f65ea 0%, #00d9ea 100%);
                font-size: 14px;
                font-weight: 600;
                color: #ffffff;
                line-height: 20px;
                padding: 0 10px 0 5px;
                border-radius: 0px;
                border: none;
            }
        }
    }

    .echart {
        margin-top: 10px;
        height: 71%;

        .dom {
            height: 100%;
            user-select: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: relative;
        }
    }

    .el-input__icon {
        line-height: 20px;
    }
}
</style>